/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

export const INPROCESS = "InProcess";
export const ACTIVE = "Active";
export const ACTIVE_VENDOR = "Active-Vendor";
export const DECLINED = "Declined";
export const RENEWAL_DECLINED = "Renewal-Declined";
export const AWARD_EXPIRED = "Award-Expired";
export const NEW_ONBOARDING = "New-Onboarding";
export const RENEWAL_ONBOARDING = "Renew-Onboarding";
export const REMOVE_CODE_OF_CONDUCT = "Removed-Code-Of-Conduct";
export const REMOVE_NDA_VIOLATION = "Removed-NDA-Violation";
export const REMOVE_CONFLICT_OF_INTEREST = "Removed-Conflict-of-Interest";
export const REMOVE_OTHER = "Removed-Other";
export const RETIRED_RESIGNED = "Retired-Resigned";
export const RETIRED_GRADUATED = "Retired-Graduated";
export const RETIRED_AWARD_RENOUNCED = "Retired-Award-Renounced";
export const RETIRED_JOINED_MICROSOFT = "Retired-Joined-Microsoft";
export const RETIRED_OTHER = "Retired-Other";
export const REMOVED_NON_COMPLIANT = "Removed-Non-compliant";
